import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';
import { plasticViewRoles } from '../../acciones-roles/departamentos/plastic-acciones-roles';

export const RepairMoldRoutes: SideBarButton = {
  data: {
    name: 'Reparacion de Moldes',
    appendUrl: './plastic',
    roles: [...plasticViewRoles.verReparacion],
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Registrar reparacion',
        url: '/repair',
        roles: [...plasticViewRoles.verReparacion],
      },
      options: PreConfigButton3,
    },
  ],
};
